import { BlockEditProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import {
  InnerBlocks,
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import ImageEditor from "../../../source/components/ImageEditor";

const ALLOWED_BLOCKS = ["yellowtree/button", "core/heading", "core/paragraph"];

export default function SlideEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "" });
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "d-flex flex-column gap-3 swiper-slide",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
      template: [
        [
          "core/paragraph",
          {
            placeholder: "Paragraph placeholder text",
          },
        ],
        [
          "core/paragraph",
          {
            placeholder: "Paragraph placeholder text",
          },
        ],
      ],
    }
  );

  return (
    <>
      <div {...blockProps}>
        <div className="content pe-4">
          <div {...innerBlocksProps} />
        </div>
      </div>
    </>
  );
}
